// Canonical origin of the public site (www, as served after the apex redirect)
export const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || 'https://www.facilykey.com').replace(/\/$/, '');

export const LOCALES = ['fr', 'en', 'ar'];
export const DEFAULT_LOCALE = 'fr';

const OG_LOCALES = { fr: 'fr_FR', en: 'en_US', ar: 'ar_MA' };
export const ogLocale = (locale) => OG_LOCALES[locale] || OG_LOCALES.fr;

// "/catalog" + "en" -> "/en/catalog"; the default locale has no prefix
export const localizedPath = (path, locale) => {
    const clean = path === '/' ? '' : path;
    return locale === DEFAULT_LOCALE ? clean || '/' : `/${locale}${clean}`;
};

export const absoluteUrl = (path, locale = DEFAULT_LOCALE) => `${SITE_URL}${localizedPath(path, locale)}`;

// "Villa de 255 m² à Dar Bouazza" -> "villa-de-255-m2-a-dar-bouazza"
export const slugify = (text = '') =>
    text
        .toString()
        .replace(/²/g, '2')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

// Public path of a listing; the "FKB<id>" suffix is what the page resolves
export const listingPath = (title, id) => `/catalog/${slugify(title) || 'bien'}-FKB${id}`;

// Listing id from a path segment such as "villa-...-FKB873" (any case)
export const listingIdFromSlug = (slug = '') => {
    const match = slug.match(/FKB(\d+)$/i) || slug.match(/FKB(\d+)/i);
    return match ? match[1] : null;
};

// Organization data shared by every page (JSON-LD)
export const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    name: 'Facilykey',
    url: SITE_URL,
    logo: `${SITE_URL}/images/logo/logo-dark.svg`,
    telephone: '+212615348229',
    email: 'contact@facilykey.com',
    address: { '@type': 'PostalAddress', addressCountry: 'MA' },
    sameAs: [
        'https://web.facebook.com/profile.php?id=100094181588390',
        'https://www.instagram.com/facilykey.official',
    ],
};
